// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js?minimize!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-0d3a1e12!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Quotes.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("7d7efc7d", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-0d3a1e12!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/Quotes.vue
// module id = ./node_modules/vue-style-loader/index.js!./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-0d3a1e12!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/Quotes.vue
// module chunks = 0